module.exports = __webpack_public_path__ + "img/1.d203f42e.png";